import app from '../app';
import LinkButton from '../../common/components/LinkButton';
import extractText from '../../common/utils/extractText';
import MinimalDiscussionListItem from './MinimalDiscussionListItem';

/**
 * The `DiscussionsSearchSource` finds and displays discussion search results in
 * the search dropdown.
 */
export default class GlobalDiscussionsSearchSource {
  results = new Map();
  resource = 'discussions';
  title() {
    return extractText(app.translator.trans('core.lib.search_source.discussions.heading'));
  }
  isCached(query) {
    return this.results.has(query.toLowerCase());
  }
  async search(query, limit) {
    query = query.toLowerCase();
    this.results.set(query, []);
    const params = {
      filter: {
        q: query
      },
      page: {
        limit
      },
      include: 'mostRelevantPost,user,firstPost,tags'
    };
    return app.store.find('discussions', params).then(results => {
      this.results.set(query, results);
      m.redraw();
    });
  }
  view(query) {
    query = query.toLowerCase();
    return (this.results.get(query) || []).map(discussion => {
      return m("li", {
        className: "DiscussionSearchResult",
        "data-index": 'discussions' + discussion.id(),
        "data-id": discussion.id()
      }, m(MinimalDiscussionListItem, {
        discussion: discussion,
        params: {
          q: query
        }
      }));
    });
  }
  customGrouping() {
    return false;
  }
  fullPage(query) {
    const filter = app.search.gambits.apply('discussions', {
      q: query
    });
    const q = filter.q || null;
    delete filter.q;
    return m("li", null, m(LinkButton, {
      icon: "fas fa-search",
      href: app.route('index', {
        q,
        filter
      })
    }, app.translator.trans('core.lib.search_source.discussions.all_button', {
      query
    })));
  }
  gotoItem(id) {
    const discussion = app.store.getById('discussions', id);
    if (!discussion) return null;
    return app.route.discussion(discussion);
  }
}
flarum.reg.add('core', 'forum/components/GlobalDiscussionsSearchSource', GlobalDiscussionsSearchSource);